export default __webpack_public_path__ + "static/media/doctors.bc46bbbb.svg";